import { defineMessages } from 'react-intl';

export const reports = defineMessages({
  title: {
    id: 'reports.title',
    description: 'Page Title',
    defaultMessage: 'Reports'
  },
  subTitle: {
    id: 'reports.subTitle',
    description: 'Page Sub Title',
    defaultMessage: 'Reports'
  },
  description: {
    id: 'reports.description',
    description: 'Page description',
    defaultMessage: 'On this page you\'ll be able to download your account level reports.'
  },
  descriptionBlocked: {
    id: 'reports.descriptionBlocked',
    description: 'Page description when user has no tickets sold',
    defaultMessage: 'You\'ll be able to download your account level reports from this page once you\'ve sold tickets or add-ons.'
  },
  customTitle: {
    id: 'reports.custom.title',
    description: 'Title shown in card header',
    defaultMessage: 'Custom Reports'
  },
  customSearchBar: {
    id: 'reports.custom.searchBar',
    description: 'Placeholder for custom reports search bar',
    defaultMessage: 'Search for a report'
  },
  customEmptyText: {
    id: 'reports.custom.empty',
    description: 'Text to show when no custom reports have been made',
    defaultMessage: 'Get access to the insights you need ー select your data points, apply filters, and schedule a report.'
  },
  customNoResults: {
    id: 'reports.custom.noResults',
    description: 'Text to show when no results are returned for search',
    defaultMessage: 'Your search returned no results...'
  },
  largeReportModalInfo: {
    id: 'reports.modal.largeEmailInfo',
    description: 'Main text on the modal that shows when reports are too big to download',
    defaultMessage: 'Due to the size of this report it will be sent via email to {email}. Please allow 5-10 minutes for the report to generate and send.'
  },
  largeReportModalGotIt: {
    id: 'reports.modal.largeEmailButton',
    description: 'Text on the button for the large reports email modal',
    defaultMessage: 'Ok got it!'
  },
  largeReportModalTitle: {
    id: 'reports.modal.largeEmailTitle',
    description: 'Main title on the modal that shows when reports are too big to download',
    defaultMessage: 'Your report is on it\'s way'
  },
  reportDownloadError: {
    id: 'reports.reportDownloadError',
    description: 'Couldn\'t download report',
    defaultMessage: 'There was an error downloading this report'
  },
  reportHeader: {
    id: 'reports.content.report',
    description: 'Content list header',
    defaultMessage: 'Report'
  },
  typeHeader: {
    id: 'reports.content.type',
    description: 'Content list header',
    defaultMessage: 'Type'
  },
  descriptionHeader: {
    id: 'reports.content.description',
    description: 'Content list header',
    defaultMessage: 'Description'
  },
  descriptionNone: {
    id: 'reports.content.noDescription',
    description: 'Message when there is no description entered',
    defaultMessage: 'No description'
  },
  dateHeader: {
    id: 'reports.content.date',
    description: 'Content list header',
    defaultMessage: 'Date created'
  },
  actionsHeader: {
    id: 'reports.content.actions',
    description: 'Content list header',
    defaultMessage: 'Actions'
  },
  quickAudit: {
    id: 'reports.quick.quickAudit',
    description: 'Quick report description',
    defaultMessage: 'Audit'
  },
  quickAuditDescription: {
    id: 'reports.quick.quickAuditDescription',
    description: 'Quick report description',
    defaultMessage: 'Summary report of your ticket sales across all events.'
  },
  quickTitle: {
    id: 'reports.quick.title',
    description: 'Title shown in card header',
    defaultMessage: 'Quick Reports'
  },
  legacyReports: {
    id: 'reports.legacy.reports',
    description: 'Title shown in card header',
    defaultMessage: 'Legacy Reports'
  },
  quickPayoutSettlement: {
    id: 'reports.quick.payoutSettlement',
    description: 'Quick report title',
    defaultMessage: 'Payout settlement'
  },
  quickAttraction: {
    id: 'reports.quick.quickAttraction',
    description: 'Quick report title',
    defaultMessage: 'Attraction'
  },
  attractionDateRangeTitle: {
    id: 'reports.quick.attractionDateRangeTitle',
    description: 'Attraction report date range dropdown title',
    defaultMessage: 'Date attending'
  },
  quickTickets: {
    id: 'reports.quick.tickets',
    description: 'Quick report title',
    defaultMessage: 'Tickets'
  },
  salesByEvent: {
    id: 'reports.salesByEvent',
    description: 'Sales by Event',
    defaultMessage: 'Sales by Event'
  },
  quickBoxOffice: {
    id: 'reports.quick.boxOffice',
    description: 'Quick report title',
    defaultMessage: 'Box office'
  },
  salesByEventDescription: {
    id: 'reports.salesByEventDescription',
    description: 'Quick report description',
    defaultMessage: 'A summary report that shows a sales breakdown for each event, including paid tickets, free tickets, and add-ons.'
  },
  quickAddOns: {
    id: 'reports.quick.addons',
    description: 'Quick report title',
    defaultMessage: 'Add-ons'
  },
  quickOrders: {
    id: 'reports.quick.orders',
    description: 'Quick report title',
    defaultMessage: 'Orders'
  },
  quickCancellations: {
    id: 'reports.quick.cancellations',
    description: 'Quick report title',
    defaultMessage: 'Cancellations'
  },
  quickAccountActivity: {
    id: 'reports.quick.accountActivity',
    description: 'Quick report title',
    defaultMessage: 'Account Activity'
  },
  quickTicketEventLevel: {
    id: 'reports.quick.ticketEventLevel',
    description: 'Quick report title',
    defaultMessage: 'Ticket Type - Event Level'
  },
  quickTicketDatetimeLevel: {
    id: 'reports.quick.ticketDatetimeLevel',
    description: 'Quick report title',
    defaultMessage: 'Ticket Type - Timeslot Level'
  },
  quickTicketTimeslotChanges: {
    id: 'reports.quick.ticketTimeslotChanges',
    description: 'Quick report title',
    defaultMessage: 'Timeslot Changes'
  },
  quickPayoutSettlementDescription: {
    id: 'reports.quick.payoutSettlementDescription',
    description: 'Quick report description',
    defaultMessage: 'Summary report of the money released to you by Universe including ticket sales, refunds, chargebacks and withdrawals.'
  },
  quickAttractionDescription: {
    id: 'reports.quick.quickAttractionDescription',
    description: 'Quick report description',
    defaultMessage: 'Summary report that shows performance for selected attraction by time period.'
  },
  quickTicketsDescription: {
    id: 'reports.quick.ticketsDescription',
    description: 'Quick report description',
    defaultMessage: 'Data on each attendee including a cost breakdown of each ticket.'
  },
  quickAddOnsDescription: {
    id: 'reports.quick.addOnsDescription',
    description: 'Quick report description',
    defaultMessage: 'Data on each attendee including a cost breakdown of each add-on.'
  },
  quickBoxOfficeDescription: {
    id: 'reports.quick.boxOfficeDescription',
    description: 'Quick report description',
    defaultMessage: 'Summary report that shows on-site sales by cashier, payment method and event.'
  },
  quickOrdersDescription: {
    id: 'reports.quick.ordersDescription',
    description: 'Quick report description',
    defaultMessage: 'Data on all buyers including a cost breakdown of each order.'
  },
  quickCancellationsDescription: {
    id: 'reports.quick.cancellationsDescription',
    description: 'Quick report description',
    defaultMessage: 'All refunded tickets for your events.'
  },
  quickAccountActivityDescription: {
    id: 'reports.quick.accountActivityDescription',
    description: 'Quick report description',
    defaultMessage: 'All the money that came into and out of your account including: ticket sales, ticket purchases, withdrawals, and chargebacks.'
  },
  quickTicketEventLevelDescription: {
    id: 'reports.quick.ticketEventLevelDescription',
    description: 'Quick report description',
    defaultMessage: 'A summary report of the number of tickets sold per ticket type per event page.'
  },
  quickTicketDatetimeLevelDescription: {
    id: 'reports.quick.ticketDatetimeLevelDescription',
    description: 'Quick report description',
    defaultMessage: 'A summary report of the number of tickets sold per ticket type per timeslot on each event page.'
  },
  quickTicketTimeslotChangesDescription: {
    id: 'reports.quick.ticketTimeslotChangesDescription',
    description: 'Quick report description',
    defaultMessage: 'A reference report detailing programmed price and quantity per ticket type per timeslot on each event page'
  },
  quickTicketTimeslotChangesMovedInfo: {
    id: 'reports.quick.quickTicketTimeslotChangesMovedInfo',
    description: 'Quick report move related information',
    defaultMessage: 'It can now be downloaded from the Reports page found in Event Manager.'
  },
  quickChargeback: {
    id: 'reports.quick.quickChargeback',
    description: 'Quick report description',
    defaultMessage: 'Chargebacks'
  },
  quickChargebackDescription: {
    id: 'reports.quick.quickChargebackDescription',
    description: 'Quick report description',
    defaultMessage: 'All disputed charges on your account for payments processed using Universe Payments.'
  },
  quickSettlement: {
    id: 'reports.quick.quickSettlement',
    description: 'Quick report description',
    defaultMessage: 'Settlement'
  },
  quickSettlementDescription: {
    id: 'reports.quick.quickSettlementDescription',
    description: 'Quick report description',
    defaultMessage: 'A summary report that shows a cost breakdown for each event, including net sales and tickets sold. (Looking for a breakdown of paid/free tickets and add-ons? Check out our new Sales by Event report!'
  },
  quickRebate: {
    id: 'reports.quick.quickRebate',
    description: 'Quick report description',
    defaultMessage: 'Rebates'
  },
  quickRebateDescription: {
    id: 'reports.quick.quickRebateDescription',
    description: 'Quick report description',
    defaultMessage: 'A summary of funds received from rebates.'
  },
  quickWaitlist: {
    id: 'reports.quick.quickWaitlist',
    description: 'Quick waitlist report title',
    defaultMessage: 'Marketing List'
  },
  quickWaitlistDescription: {
    id: 'reports.quick.quickWaitlistDescription',
    description: 'Quick waitlist report description',
    defaultMessage: 'A list of fans interested in staying up to date with your events.'
  },
  quickDownloadDisabledDescription: {
    id: 'reports.quick.quickDownloadDisabledDescription',
    description: 'Quick waitlist report description when privacy policy is not provided',
    defaultMessage: 'Provide your privacy policy to enable this list.'
  },
  modalWarning: {
    id: 'reports.modal.warning',
    description: 'Warning in delete reports modal',
    defaultMessage: 'Are you sure you want to delete this report? This action cannot be undone.'
  },
  movedWarning: {
    id: 'reports.movedWarning',
    description: 'Report got moved',
    defaultMessage: 'This report has moved!'
  },
  disputedStatusMovedTitle: {
    id: 'reports.disputedStatusMovedTitle',
    description: 'Title of the banner explaining Disputed status has moved out of the Orders Report',
    defaultMessage: 'Looking for chargeback information?'
  },
  disputedStatusMovedMessage: {
    id: 'reports.disputedStatusMovedMessage',
    description: 'Body of the banner explaining Disputed status has moved out of the Orders Report',
    defaultMessage: 'Disputed status has moved out of the Orders Report. Track chargebacks and their effect on your earnings in the Chargebacks Report or Payout Settlement Report.'
  },
  disputedStatusMovedDismiss: {
    id: 'reports.disputedStatusMovedDismiss',
    description: 'Accessible label for the button that dismisses the Disputed status banner',
    defaultMessage: 'Dismiss'
  }
});

export const reportActions = defineMessages({
  downloadBtn: {
    id: 'reports.download',
    description: 'Text for download btn',
    defaultMessage: 'Download'
  },
  selectDateRangeAndDownloadBtn: {
    id: 'reports.quick.selectDateRangeAndDownload.',
    description: 'Text for quick reports download btn on main page',
    defaultMessage: 'Select Date Range'
  },
  customCreateBtn: {
    id: 'reports.custom.createBtn',
    description: 'Text for create button',
    defaultMessage: 'Create report'
  },
  customSaveBtn: {
    id: 'reports.custom.saveBtn',
    description: 'Text for create button, saving only',
    defaultMessage: 'Save custom report'
  },
  extendedAuditReport: {
    id: 'reports.modal.extendedAuditReport',
    description: 'Text for downloading extended report',
    defaultMessage: 'Include net sales breakdown'
  },
  modalDownloadReportBtn: {
    id: 'reports.modal.downloadReport',
    description: 'Text for download report btn',
    defaultMessage: 'Download Report'
  },
  modalCancelBtn: {
    id: 'reports.modal.cancelBtn',
    description: 'Text for cancel btn in delete reports modal',
    defaultMessage: 'Cancel'
  },
  modalDeleteBtn: {
    id: 'reports.modal.deleteBtn',
    description: 'Text for delete btn in delete reports modal',
    defaultMessage: 'Delete custom report'
  },
  customEditOption: {
    id: 'reports.custom.edit',
    description: 'Edit text in more actions menu',
    defaultMessage: 'Edit'
  },
  customDeleteOption: {
    id: 'reports.custom.delete',
    description: 'Delete text in more actions menu',
    defaultMessage: 'Delete report'
  },
  waitlistReportTooltip: {
    id: 'reports.custom.waitlistReportTooltip',
    description: 'Tooltip message when waitlist report download button is disabled',
    defaultMessage: 'Add your own privacy policy via your Account Settings to begin collecting a marketing list.'
  }
});

export const breakdownTypeOptions = defineMessages({
  summaryReport: {
    id: 'reports.modal.summaryReport',
    description: 'Text for filter by options field',
    defaultMessage: 'Summary report'
  },
  itemizedReport: {
    id: 'reports.modal.itemizedReport',
    description: 'Text for filter by options field',
    defaultMessage: 'Itemized report'
  }
});

export const reportOptions = defineMessages({
  filterByPast7Days: {
    id: 'reports.options.filterBy.past7Days',
    description: 'Text for filter by options field',
    defaultMessage: 'Past 7 Days'
  },
  filterByPast30Days: {
    id: 'reports.options.filterBy.past30Days',
    description: 'Text for filter by options field',
    defaultMessage: 'Past 30 Days'
  },
  filterByAllTransactions: {
    id: 'reports.options.filterBy.allTransactions',
    description: 'Text for filter by options field',
    defaultMessage: 'All Transactions'
  },
  filterBySingleDay: {
    id: 'reports.options.filterBy.singleDay',
    description: 'Text for filter by options field',
    defaultMessage: 'Single Day'
  },
  filterByCustomDateRange: {
    id: 'reports.options.filterBy.customDateRange',
    description: 'Text for filter by options field',
    defaultMessage: 'Custom Date Range'
  }
});

export const customReports = defineMessages({
  createTitle: {
    id: 'reports.custom.createTitle',
    description: 'Create Page Title',
    defaultMessage: 'Create custom report'
  },
  editTitle: {
    id: 'reports.custom.createEdit',
    description: 'Edit Page Title',
    defaultMessage: 'Edit custom report'
  },
  createSubTitle: {
    id: 'reports.custom.createSubtitle',
    description: 'Create Page Subtitle',
    defaultMessage: 'Create and customize a report to get the insights you need to inform your business decisions.'
  },
  editSubTitle: {
    id: 'reports.custom.editSubtitle',
    description: 'Edit Page Subtitle',
    defaultMessage: 'Customize your report to get the insights you need to inform your business decisions.'
  },
  backToReports: {
    id: 'reports.custom.backToReports',
    description: 'Navigating back a page to the main reports page.',
    defaultMessage: 'Back to reports'
  },
  attendeesReport: {
    id: 'reports.custom.reportType.attendeesReport',
    description: 'A type of report available to download.',
    defaultMessage: 'Attendees Report'
  },
  addOnsReport: {
    id: 'reports.custom.reportType.addOnsReport',
    description: 'A type of report available to download.',
    defaultMessage: 'Add-ons Report'
  },
  ordersReport: {
    id: 'reports.custom.reportType.ordersReport',
    description: 'A type of report available to download.',
    defaultMessage: 'Orders Report'
  },
  ticketsReport: {
    id: 'reports.custom.reportType.ticketsReport',
    description: 'A type of report available to download.',
    defaultMessage: 'Tickets Report'
  },
  reportInformation: {
    id: 'reports.custom.reportInformation',
    description: 'Header for report information card.',
    defaultMessage: 'Report information'
  },
  reportType: {
    id: 'reports.custom.reportType',
    description: 'Header for report type field.',
    defaultMessage: 'Report type'
  },
  reportName: {
    id: 'reports.custom.reportName',
    description: 'Header for report name field.',
    defaultMessage: 'Report name'
  },
  addDescription: {
    id: 'reports.custom.addDescription',
    description: 'Header for the description field.',
    defaultMessage: 'Description (optional)'
  },
  errorReportTypeRequired: {
    id: 'reports.custom.errorReportTypeRequired',
    description: 'Error message for when a report type is not selected.',
    defaultMessage: 'Report type is required.'
  },
  errorReportNameRequired: {
    id: 'reports.custom.errorReportNameRequired',
    description: 'Error message for when a report name is not entered.',
    defaultMessage: 'Report name is required.'
  },
  setupReport: {
    id: 'reports.custom.setupReport',
    description: 'Header for setup card.',
    defaultMessage: 'Setup report'
  },
  setupDescription: {
    id: 'reports.custom.setupDescription',
    description: 'Sub-header for setup card.',
    defaultMessage: 'Select events to appear in report'
  },
  showColumns: {
    id: 'reports.custom.showColumns',
    description: 'Header for columns card.',
    defaultMessage: 'Show columns'
  },
  showColumnsDescription: {
    id: 'reports.custom.showColumnsDescription',
    description: 'Sub-header for columns card.',
    defaultMessage: 'Select at least 1 column to build a report'
  },
  showMoreOptions: {
    id: 'reports.custom.showMoreOptions',
    description: 'Button to show more column options.',
    defaultMessage: 'Show more'
  },
  showLessOptions: {
    id: 'reports.custom.showLessOptions',
    description: 'Button to show less column options.',
    defaultMessage: 'Show less'
  },
  errorColumnsDescription: {
    id: 'reports.custom.errorColumnsDescription',
    description: 'Error for when zero columns are selected.',
    defaultMessage: 'You must select at least 1 column to build a report'
  },
  saveDateCustomReport: {
    id: 'reports.custom.saveDateCustomReport',
    description: 'Button to save a custom report.',
    defaultMessage: 'Save'
  },
  errorFileExtensionRequired: {
    id: 'reports.custom.errorFileExtensionRequired',
    description: 'Error for when a file extension is not entered (deprecated)',
    defaultMessage: 'A file extension is required.'
  },
  dashboard: {
    id: 'reports.custom.dashboard',
    description: 'Link to dashboard page',
    defaultMessage: 'Dashboard'
  },
  addFilters: {
    id: 'reports.custom.addFilters',
    description: 'Header for the filters card.',
    defaultMessage: 'Add filters'
  },
  dateOfOrder: {
    id: 'reports.custom.dateOfOrder',
    description: 'Header for the date of order select field.',
    defaultMessage: 'Date of order'
  },
  dateAttending: {
    id: 'reports.custom.dateAttending',
    description: 'Header for the date attending select field.',
    defaultMessage: 'Date attending'
  },
  purchaseSource: {
    id: 'reports.custom.purchaseSource',
    description: 'Header for the purchase source filter field.',
    defaultMessage: 'Purchase source'
  },
  paymentStatus: {
    id: 'reports.custom.paymentStatus',
    description: 'Header for the payment status filter field.',
    defaultMessage: 'Payment status'
  },
  paymentStatusError: {
    id: 'reports.custom.paymentStatusError',
    description: 'Error for the payment status filter field.',
    defaultMessage: 'Payment status is required.'
  },
  teamMemberEmails: {
    id: 'reports.custom.teamMemberEmails',
    description: 'Header for the Team member emails filter field.',
    defaultMessage: 'Team member emails'
  },
  teamMemberEmailsPlaceholder: {
    id: 'reports.custom.teamMemberEmailsPlaceholder',
    description: 'Placeholder for the Team member emails input.',
    defaultMessage: 'Select...'
  },
  externalRecipient: {
    id: 'reports.custom.externalRecipient',
    description: 'Header for the External Recipient field.',
    defaultMessage: 'External recipients'
  },
  externalRecipientPlaceholder: {
    id: 'reports.custom.externalRecipientPlaceholder',
    description: 'Placeholder for the External Recipient input.',
    defaultMessage: 'Enter email addresses'
  },
  sortBy: {
    id: 'reports.custom.sortBy',
    description: 'Header for the sort card.',
    defaultMessage: 'Sort by'
  },
  alphabetically: {
    id: 'reports.custom.alphabetically',
    description: 'Header for the sort-alphabetically sort field.',
    defaultMessage: 'Alphabetically'
  },
  allDates: {
    id: 'reports.custom.allDates',
    description: 'Option for date filter/sort field.',
    defaultMessage: 'All dates'
  },
  pastThirtyDays: {
    id: 'reports.custom.pastThirtyDays',
    description: 'Option for date filter/sort field.',
    defaultMessage: 'Past 30 days'
  },
  pastSevenDays: {
    id: 'reports.custom.pastSevenDays',
    description: 'Option for date filter/sort field.',
    defaultMessage: 'Past 7 days'
  },
  pastDay: {
    id: 'reports.custom.pastDay',
    description: 'Option for date filter/sort field.',
    defaultMessage: 'Past 24 hours'
  },
  onSpecificDay: {
    id: 'reports.custom.onSpecificDay',
    description: 'Option for date filter/sort field.',
    defaultMessage: 'On a specific day...'
  },
  beforeSpecificDay: {
    id: 'reports.custom.beforeSpecificDay',
    description: 'Option for date filter/sort field.',
    defaultMessage: 'Before a specific day...'
  },
  afterSpecificDay: {
    id: 'reports.custom.afterSpecificDay',
    description: 'Option for date filter/sort field.',
    defaultMessage: 'After a specific day...'
  },
  customDateRange: {
    id: 'reports.custom.customDateRange',
    description: 'Option for date filter/sort field.',
    defaultMessage: 'Date range'
  },
  facebook: {
    id: 'reports.custom.facebook',
    description: 'Option for Payment Source field.',
    defaultMessage: 'Facebook'
  },
  greaterThan: {
    id: 'reports.custom.greaterThan',
    description: 'Option for sort field.',
    defaultMessage: 'Greater than'
  },
  lessThan: {
    id: 'reports.custom.lessThan',
    description: 'Option for sort field.',
    defaultMessage: 'Less than'
  },
  all: {
    id: 'reports.custom.all',
    description: 'Option for sort field.',
    defaultMessage: 'All'
  },
  allPaymentStates: {
    id: 'reports.custom.allPaymentStates',
    description: 'Option for payment state filter.',
    defaultMessage: 'All states'
  },
  paid: {
    id: 'reports.custom.paid',
    description: 'Option for payment state filter.',
    defaultMessage: 'Paid'
  },
  unpaid: {
    id: 'reports.custom.unpaid',
    description: 'Option for payment state filter.',
    defaultMessage: 'Unpaid'
  },
  cancelled: {
    id: 'reports.custom.cancelled',
    description: 'Option for payment state filter.',
    defaultMessage: 'Cancelled'
  },
  unauthorized: {
    id: 'reports.custom.unauthorized',
    description: 'Option for payment state filter.',
    defaultMessage: 'Unauthorized'
  },
  expired: {
    id: 'reports.custom.expired',
    description: 'Option for payment state filter.',
    defaultMessage: 'Expired'
  },
  partiallyPaid: {
    id: 'reports.custom.partiallyPaid',
    description: 'Option for payment state filter.',
    defaultMessage: 'Partially Paid'
  },
  closed: {
    id: 'reports.custom.closed',
    description: 'Option for payment state filter.',
    defaultMessage: 'Closed'
  },
  ended: {
    id: 'reports.custom.ended',
    description: 'Option for payment state filter.',
    defaultMessage: 'Ended'
  },
  failed: {
    id: 'reports.custom.failed',
    description: 'Option for payment state filter.',
    defaultMessage: 'Failed'
  },
  processing: {
    id: 'reports.custom.processing',
    description: 'Option for payment state filter.',
    defaultMessage: 'Processing'
  },
  error: {
    id: 'reports.custom.error',
    description: 'Option for payment state filter.',
    defaultMessage: 'Error'
  },
  transferred: {
    id: 'reports.custom.transferred',
    description: 'Option for payment state filter.',
    defaultMessage: 'Transferred'
  },
  upgraded: {
    id: 'reports.custom.upgraded',
    description: 'Option for payment state filter.',
    defaultMessage: 'Upgraded'
  },
  declined: {
    id: 'reports.custom.declined',
    description: 'Option for payment state filter.',
    defaultMessage: 'Declined'
  },
  unapproved: {
    id: 'reports.custom.unapproved',
    description: 'Option for payment state filter.',
    defaultMessage: 'Unapproved'
  },
  pending: {
    id: 'reports.custom.pending',
    description: 'Option for payment state filter.',
    defaultMessage: 'Pending'
  },
  byFirstName: {
    id: 'reports.custom.byFirstName',
    description: 'Option for sorting.',
    defaultMessage: 'By first name'
  },
  byLastName: {
    id: 'reports.custom.byLastName',
    description: 'Option for sorting.',
    defaultMessage: 'By last name'
  },
  byNewest: {
    id: 'reports.custom.byNewest',
    description: 'Option for sorting.',
    defaultMessage: 'By newest'
  },
  beforeSpecificDayDisp: {
    id: 'reports.custom.beforeSpecificDayDisp',
    description: 'Date filter for when user desires data before a certain date.',
    defaultMessage: 'Before {date}'
  },
  afterSpecificDayDisp: {
    id: 'reports.custom.afterSpecificDayDisp',
    description: 'Date filter for when user desires data after a certain date.',
    defaultMessage: 'After {date}'
  },
  customDateRangeDisp: {
    id: 'reports.custom.customDateRangeDisp',
    description: 'Date filter for when user desires data within a certain date range.',
    defaultMessage: '{start} - {end}'
  },
  selectAllColumns: {
    id: 'reports.custom.selectAllColumns',
    description: 'Checkbox label for seleting all columns',
    defaultMessage: 'Select All'
  },
  schedule: {
    id: 'reports.custom.scheduler.schedule',
    description: 'Schedule',
    defaultMessage: 'Schedule'
  },
  emailedTo: {
    id: 'reports.custom.scheduler.emailedTo',
    description: 'Emailing instruction',
    defaultMessage: 'This report will be emailed to'
  },
  schedulerWarning: {
    id: 'reports.custom.scheduler.Warning',
    description: 'Warning for users that the scheduler will be turned off automatically if no events are in the future.',
    defaultMessage: 'If all events are in the past, this report will no longer send.'
  },
  schedulerDateRange: {
    id: 'reports.custom.scheduler.DateRange',
    description: 'Date range for custom report scheduler',
    defaultMessage: 'Date range'
  },
  frequency: {
    id: 'reports.custom.scheduler.frequency',
    description: 'Frequency for custom report scheduler',
    defaultMessage: 'Frequency'
  },
  schedulerSelectDay: {
    id: 'reports.custom.scheduler.selectDay',
    description: 'Day options for custom report scheduler',
    defaultMessage: 'Select day'
  },
  schedulerSelectHour: {
    id: 'reports.custom.scheduler.selectHour',
    description: 'Hour options for custom report scheduler',
    defaultMessage: 'Select time'
  },
  schedulerScheduleReport: {
    id: 'reports.custom.scheduler.scheduleReport',
    description: 'Scheduler toggle button label',
    defaultMessage: 'Schedule this report'
  },
  schedulerDisableScheduler: {
    id: 'reports.custom.scheduler.disableScheduler',
    description: 'Scheduler toggle button label',
    defaultMessage: 'Disable schedule'
  },
  suppressPrimaryRecipient: {
    id: 'reports.custom.scheduler.suppressPrimaryRecipient',
    description: 'Toggle label to suppress sending the report to the account owner',
    defaultMessage: 'Don\'t send this report to me'
  },
  schedulerConfirm: {
    id: 'reports.custom.scheduler.confirm',
    description: 'Confirm button label',
    defaultMessage: 'Confirm'
  },
  schedulerFrequencyDaily: {
    id: 'reports.custom.scheduler.daily',
    description: 'Daily frequency text label',
    defaultMessage: 'Daily'
  },
  schedulerFrequencyWeekly: {
    id: 'reports.custom.scheduler.weekly',
    description: 'Weekly frequency text label',
    defaultMessage: 'Weekly'
  },
  schedulerMonday: {
    id: 'reports.custom.scheduler.monday',
    description: 'Monday',
    defaultMessage: 'Monday'
  },
  schedulerTuesday: {
    id: 'reports.custom.scheduler.tuesday',
    description: 'Tuesday',
    defaultMessage: 'Tuesday'
  },
  schedulerWednesday: {
    id: 'reports.custom.scheduler.wednesday',
    description: 'Wednesday',
    defaultMessage: 'Wednesday'
  },
  schedulerThursday: {
    id: 'reports.custom.scheduler.thursday',
    description: 'Thursday',
    defaultMessage: 'Thursday'
  },
  schedulerFriday: {
    id: 'reports.custom.scheduler.friday',
    description: 'Friday',
    defaultMessage: 'Friday'
  },
  schedulerSaturday: {
    id: 'reports.custom.scheduler.saturday',
    description: 'Saturday',
    defaultMessage: 'Saturday'
  },
  schedulerSunday: {
    id: 'reports.custom.scheduler.sunday',
    description: 'Sunday',
    defaultMessage: 'Sunday'
  },
  created_at__desc: {
    id: 'reports.custom-reports.sort-by-date-descending',
    defaultMessage: 'Newest to Oldest Date of Order',
    description: 'sort report by decending date'
  },
  created_at__asc: {
    id: 'reports.custom-reports.sort-by-date-ascending',
    defaultMessage: 'Oldest to Newest Date of Order',
    description: 'sort report by ascending date'
  },
  first_name__asc: {
    id: 'reports.custom-reports.sort-by-first-name',
    defaultMessage: 'First Name',
    description: 'sort report by first name (a-z)'
  },
  last_name__asc: {
    id: 'reports.custom-reports.sort-by-last-name',
    defaultMessage: 'Last Name',
    description: 'sort report by last name (a-z)'
  },
  buyer_first_name__asc: {
    id: 'reports.custom-reports.sort-by-buyer-first-name',
    defaultMessage: 'Buyer\'s First Name',
    description: 'sort report by buyer\'s first name (a-z)'
  },
  buyer_last_name__asc: {
    id: 'reports.custom-reports.sort-by-buyer-last-name',
    defaultMessage: 'Buyer\'s Last Name',
    description: 'sort report by buyer\'s last name (a-z)'
  },
  selectStatus: {
    id: 'reports.custom-reports.selectStatus',
    defaultMessage: 'Select status',
    description: 'placeholder for payment status'
  }
});



// WEBPACK FOOTER //
// ./src/routes/reports/locale/index.js